/**
 * @generated SignedSource<<d17bafc3be732ea3349f693dd970a4db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EmailSignupVerficationInput = {
  id: string;
  token: string;
};
export type VerifyEmailSignupPageCheckMutation$variables = {
  input: EmailSignupVerficationInput;
};
export type VerifyEmailSignupPageCheckMutation$data = {
  readonly checkEmailSignupVerification: {
    readonly emailCanResendAt: string;
    readonly id: string;
  };
};
export type VerifyEmailSignupPageCheckMutation = {
  response: VerifyEmailSignupPageCheckMutation$data;
  variables: VerifyEmailSignupPageCheckMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailSignupRequest",
    "kind": "LinkedField",
    "name": "checkEmailSignupVerification",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailCanResendAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyEmailSignupPageCheckMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifyEmailSignupPageCheckMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "02631d8ee9e588b747394b580d7e66a5",
    "id": null,
    "metadata": {},
    "name": "VerifyEmailSignupPageCheckMutation",
    "operationKind": "mutation",
    "text": "mutation VerifyEmailSignupPageCheckMutation(\n  $input: EmailSignupVerficationInput!\n) {\n  checkEmailSignupVerification(input: $input) {\n    id\n    emailCanResendAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "a8ba4a531f2b1bf8e84aaacd122b69a8";

export default node;
